import React from 'react';
import data from './data';
import ProDeskCardGrid from '../ProDeskCardGrid/ProDeskCardGrid';

export const ProDeskProXtraPods = () => (
  <div className="sui-mt-10" data-component="ProDeskProXtraPods">
    <ProDeskCardGrid
      title="Pro Xtra Loyalty Program"
      data={data}
      trackingParam="?emt=PD_proxtra"
      ctaText="Explore More"
    />
  </div>
);

ProDeskProXtraPods.displayName = 'ProDeskProXtraPods';